(function() {
  'use strict';

  function getTabsEl(link) {
    var c = link.closest('.mega-menu__container');
    return c ? c.querySelector('tabs-element') : null;
  }

  function getVisibleContent(panel) {
    var main = panel.querySelector('.mega-menu__panel-main');
    var subs = panel.querySelectorAll('.mega-menu__panel-sub');
    if (main && !main.classList.contains('hidden')) return main;
    for (var i = 0; i < subs.length; i++) {
      if (!subs[i].classList.contains('hidden')) return subs[i];
    }
    return null;
  }

  function clearNavActive(nav) {
    nav.querySelectorAll('.mega-menu__submenu-link').forEach(function(l) {
      l.classList.remove('is-active');
      l.removeAttribute('aria-current');
    });
  }

  function setActiveNavLink(link) {
    if (link) {
      link.classList.add('is-active');
      link.setAttribute('aria-current', 'page');
    }
  }

  function hideSubs(subs, except) {
    subs.forEach(function(el) {
      if (el !== except) {
        el.classList.add('hidden');
        el.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function switchContent(fromEl, toEl, callback, panelJustRevealed) {
    if (fromEl && toEl && fromEl === toEl) {
      if (callback) callback();
      return;
    }
    if (fromEl) { fromEl.classList.add('hidden'); fromEl.setAttribute('aria-hidden', 'true'); }
    if (toEl) {
      toEl.classList.remove('hidden');
      toEl.removeAttribute('aria-hidden');
      var ml = toEl.querySelector('motion-list');
      var shouldLoad = panelJustRevealed || !toEl.classList.contains('mega-menu__panel-main');
      if (ml && typeof ml.load === 'function' && shouldLoad) ml.load();
    }
    if (callback) callback();
  }

  function switchPanel(e, link, state) {
    if (!link || !link.dataset.panelId) return;
    if (state.switching) return;
    state.switching = true;

    var panel = document.getElementById(link.dataset.panelId);
    if (!panel) { state.switching = false; return; }
    var main = panel.querySelector('.mega-menu__panel-main');
    var subs = panel.querySelectorAll('.mega-menu__panel-sub');
    var nav = panel.querySelector('.mega-menu__submenu');
    if (!nav) { state.switching = false; return; }

    var panelId = link.dataset.panelId;
    var isFirstPanel = panelId.lastIndexOf('-0') === panelId.length - 2;
    var panelVisible = !panel.hidden;
    var tabs = getTabsEl(link);

    var panelJustRevealed = false;
    if (isFirstPanel && tabs && !panelVisible) {
      panel.dataset.megaMenuProgrammaticShow = '1';
      tabs.setAttribute('selected-index', '0');
      panelJustRevealed = true;
    }

    function done() { state.switching = false; }

    if (link.dataset.showMain === 'true') {
      e.preventDefault();
      clearNavActive(nav);
      setActiveNavLink(nav.querySelector('.mega-menu__submenu-link--main'));
      switchContent(getVisibleContent(panel), main, function() {
        hideSubs(subs);
        done();
      }, panelJustRevealed);
      return;
    }

    if (link.dataset.collectionUrl) {
      e.preventDefault();
      var target = Array.prototype.find.call(subs, function(el) { return el.getAttribute('data-collection-url') === link.dataset.collectionUrl; });
      if (!target) { done(); return; }
      clearNavActive(nav);
      setActiveNavLink(Array.prototype.find.call(nav.querySelectorAll('.mega-menu__submenu-link[data-collection-url]'), function(l) { return l.getAttribute('data-collection-url') === link.dataset.collectionUrl; }));
      switchContent(getVisibleContent(panel), target, function() {
        if (main) main.classList.add('hidden');
        hideSubs(subs, target);
        done();
      }, panelJustRevealed);
    } else {
      done();
    }
  }

  function onToggle(e) {
    if (!e.target.matches('.mega-menu__tab-as-dropdown')) return;
    var details = e.target;
    var wrap = details.closest('.mega-menu__tab-dropdown-wrap');
    var inline = wrap && wrap.querySelector('.mega-menu__tab-dropdown-inline');
    if (inline) inline.hidden = !details.open;
    if (details.open) {
      var container = details.closest('.mega-menu__container');
      var tabsEl = container && container.querySelector('tabs-element');
      if (tabsEl) {
        var idx = details.getAttribute('data-tab-index');
        if (idx != null) tabsEl.setAttribute('selected-index', idx);
      }
    }
  }

  function init() {
    if (window.__megaMenuPanelClickBound) return;
    window.__megaMenuPanelClickBound = true;

    document.addEventListener('toggle', onToggle, true);

    var state = { switching: false };
    document.addEventListener('click', function(e) {
      var link = e.target.closest('.mega-menu__tab-dropdown-inline__link, .mega-menu__submenu-link');
      if (!link || !link.dataset.panelId) return;
      if (!link.dataset.showMain && !link.dataset.collectionUrl) return;
      e.preventDefault();
      e.stopPropagation();
      switchPanel(e, link, state);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
